export const componentMapping = {
    textpic: {
        default: 'picture-and-text',
        'layout-1': 'split-section',
        'layout-2': 'split-section',
        'layout-3': 'call-to-action',
        'layout-4': 'hero-banner',
        'layout-5': 'product-box-element',
        'layout-6': 'product-box-element-quarter',
        'layout-7': 'content-preview',
    },
    image: {
        default: 'banner',
    },
    text: {
        default: 'rich-text',
    },
    header: {
        default: 'rich-text',
    },
    menu_categorized_content: {
        default: 'story-navigation',
    },
    div: {
        default: 'divider',
    },
    html: {
        default: 'h-t-m-l-view',
    },
};
